<template>
    <div class="table__responsive table__specified-widths">
        <table class="table">
            <thead>
                <tr>
                    <th colspan="4" class="table__wrap">{{$t('invoice_details.table.header.product')}}</th>
                    <th colspan="3">{{$t('invoice_details.table.header.amount')}}</th>
                    <th>{{$t('invoice_details.table.header.ppu')}}</th>
                    <th>{{$t('invoice_details.table.header.vat_percentage')}}</th>
                    <th class="table__cell--icon"></th>
                    <th class="table__cell--icon"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in items" :key="item.id">
                    <td colspan="4" class="table__wrap">{{ item.invoice_product.name }}</td>
                    <td colspan="3">{{ item.count }}</td>
                    <td>{{ item.unit_price | toCurrency }}</td>
                    <td>{{ item.vat_percentage }}</td>
                    <td><span @click="editItem(item)" v-tooltip.bottom="$t('invoice_details.table.edit_item')" class="table__icon icons icon-pencil"></span></td>
                    <td><span @click="showDeleteItem(item)" v-tooltip.bottom="$t('invoice_details.table.delete_item')" class="table__icon icons icon-trash"></span></td>
                </tr>

                <tr class="row__btn">
                    <td colspan="11" @click="addNew">
                        <i class="icons icon-plus"></i>
                        <a class="button--link--cta">{{$t('invoice_details.table.add_new')}}</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <invoice-item-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import InvoiceItemModal from '@/components/modals/invoice-details/InvoiceItemModal';
    import InvoiceItem from '@/models/InvoiceItem';

    import { GET_INVOICE } from '@/store/modules/invoice';

    @Component({
        components: {
            InvoiceItemModal,
        }
    })
    export default class InvoiceItemsTable extends Vue {
        name = 'invoice-items-table';

        @Prop()
        items;

        addNew() {
            const trajectoryId = this.$store.state.trajectory.trajectory.id;
            const invoiceId = this.$store.state.invoice.invoice.id;
            const url = `/trajectories/${trajectoryId}/invoices/${invoiceId}/rows`;
            const invoiceItem = new (InvoiceItem.makeModel(url));
            this.$modal.show('invoice-item-modal', { invoiceItem });
        }

        editItem(invoiceItem) {
            this.$modal.show('invoice-item-modal', { invoiceItem });
        }

        showDeleteItem(item) {
            const content = {
                title: this.$t('modals.delete_invoice_item.title'),
                message: this.$t('modals.delete_invoice_item.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteItem, item});
        }

        deleteItem({item}) {
            item.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.invoice_item.delete_success'));
                    this.$store.dispatch(GET_INVOICE, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.invoice_item.delete_error')));
        }


    }
</script>



// WEBPACK FOOTER //
// src/components/tables/invoice-details/InvoiceItemsTable.vue